const GiftVoucherDeliveryTypeEnum = Object.freeze({
    EMAIL: 'Email',
    IN_PERSON: 'In Person',
    POST: 'Post',
});

module.exports = GiftVoucherDeliveryTypeEnum;
